$(window).on('load', function () {
    // set up the animation delays on the overlay menu
    $('ul.overlay-menu a').each(function(i, el){
        let seconds = ((i+1)/15);
        $(this).css('animation-delay', seconds+'s');
    });
    $('ul.overlay-menu .sub-menu .sub-item a').each(function(i, el){
        let seconds = ((i+1)/20);
        $(this).css('animation-delay', seconds+'s');
    });

    $('ul.overlay-menu a').click(function() {
        $(this).parent().toggleClass('-expanded');
    })

    $('.nav .nav-search .search-form-toggle').clickToggle(function() {
        $('.search_form').addClass('-show');
    },
    function() {
        $('.search_form').removeClass('-show');
    });

    $('.navbar-mobile-menu button.hamburger').clickToggle(function() {
        $(this).addClass('is-active');
        $("#hamburgerMenuOverlay").modal({
            backdrop: 'static',
            keyboard: false
        });
    }, function() {
        $('ul.overlay-menu').removeClass('is-active');
        $(this).removeClass('is-active');
        $("#hamburgerMenuOverlay").modal('hide');
    });

    $('#show-more-tags').click(function() {
        $(this).hide();
        $('.tags').removeClass('-hide-some');
    })

});
